"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require("./native-events-handlers"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vidi/dist/src/events/index.js
// module id = 2761
// module chunks = 66